import { Paper } from '@mui/material';
import { Stack, styled } from '@mui/system';

const Container = styled(Paper)({
  width: '400px',
  padding: '40px',
});

const Content = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(5),
  borderTop: `1px dashed ${theme.palette.border.default}`,
  borderImage:
    'repeating-linear-gradient(90deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  gap: theme.spacing(3),
}));

const Form = styled('form')({});

export { Container, Content, Form };
